import Vue from 'vue'
import navSettings from '@/components/Navigation/navigation-settings'
import buildClient from '@/api/client'
import navigationQuery from '@/api/navigation.gql'

const Debouncer = On.Debouncer()

export const NOTICE_MESSAGE_CONTEXT_DEFAULT = 'default'

export default {
  namespaced: true,
  state: {
    navigationVariant: {},
    account: {},
    accountNavMustStayOpen: false,
    activeCardVariant: {},
    additionalMainLinks: [],
    currentAdditionalNav: '',
    cartItemNumber: -1,
    currentBlock: -1,
    currentSection: -1,
    currentTopic: -1,
    deliveryNotice: '',
    preferredDeliveryNotice: '',
    desktopNavigation: window.innerWidth > navSettings.mobileBreakpoint,
    locale: {},
    search: {},
    stores: {},
    subNavigationDesktop: {},
    overlayIsOpen: false,
    subNavIsOpen: false,
    dropdownNavIsBlocked: true,
    dropdownNavBlockToggleConditions: [],
    subNavigation: {},
    topics: [{ blocks: [{ themeImage: '' }] }],
    noticeMessagesByContext: {
      [NOTICE_MESSAGE_CONTEXT_DEFAULT]: {
        message: '',
        variant: '',
      },
    },
  },
  mutations: {
    setState(state, payload) {
      Vue.set(state, [payload['key']], payload['value'])
    },
    setNavigationVariant(state, payload) {
      state.navigationVariant = payload
    },
    setAccountNavMustStayOpen(state, payload) {
      state.accountNavMustStayOpen = payload
    },
    setCurrentTopic(state, payload) {
      state.currentTopic = payload
    },
    setCurrentBlock(state, payload) {
      state.currentBlock = payload
    },
    setCurrentSection(state, payload) {
      state.currentSection = payload
    },
    setCurrentAdditionalNav(state, payload) {
      state.currentAdditionalNav = payload
    },
    setSubnavState(state, payload) {
      state.subNavIsOpen = payload
    },
    setOverlayState(state, payload) {
      state.overlayIsOpen = payload
    },
    blockDropdownNav(state) {
      state.dropdownNavIsBlocked = true
    },
    unblockDropdownNav(state) {
      state.dropdownNavIsBlocked = false
    },
    addDropdownNavBlockToggleCondition(state, payload) {
      state.dropdownNavBlockToggleConditions.push(payload)
    },
    setActiveCardVariant(state, payload) {
      state.activeCardVariant = payload
    },
    setPreferredDeliveryNotice(state, payload) {
      state.preferredDeliveryNotice = payload
    },
    setNoticeMessage(state, payload) {
      let { context } = payload
      Vue.set(state.noticeMessagesByContext, context || NOTICE_MESSAGE_CONTEXT_DEFAULT, payload)
    },
  },
  actions: {
    updateState({ commit }, payload) {
      commit('setState', payload)
    },
    toggleSubnav({ state, commit }, payload) {
      commit('setOverlayState', payload)
      commit('setSubnavState', payload)
      // Only mobile reset subnav when closing it
      if (!payload && !state.desktopNavigation) commit('setCurrentTopic', -1)
    },
    setAdditionalNav({ state, commit, rootGetters }, payload) {
      if (rootGetters['page/isCartPage'] && payload === 'mini-cart') return
      let debounceDelay = payload === '' ? 0 : 250
      trackEvents(payload, state.currentAdditionalNav)
      Debouncer.debounce({
        debounceTime: debounceDelay,
        callback: function() {
          commit('setCurrentAdditionalNav', payload)
          if (payload === 'mini-cart' || payload === 'search') commit('setOverlayState', true)
        },
      })
    },
    updateNoticeMessage({ commit }, payload) {
      commit('setNoticeMessage', payload)
    },

    async fetchNavigationVariant({ dispatch }) {
      const { navigation } = await buildClient().query(navigationQuery)
      dispatch('setNavigationVariant', navigation)
    },
    setNavigationVariant({ commit }, navigationVariant) {
      commit('setNavigationVariant', navigationVariant)
    },
  },
  getters: {
    activeCardVariant: state => state.activeCardVariant,
    additionalMainLinks: state => state.additionalMainLinks,
    currentAdditionalNav: state => state.currentAdditionalNav,
    currentTopic: state => state.currentTopic,
    deliveryNotice: state => state.preferredDeliveryNotice || state.deliveryNotice,
    dropdownNavIsBlocked: state => state.dropdownNavIsBlocked,
    outOfStockOverlay: state => state.outOfStockOverlay,
    overlayIsOpen: state => state.overlayIsOpen,
    shouldAvoidBlockToggling: state => e =>
      state.dropdownNavBlockToggleConditions.some(conditionFn => conditionFn(e)),
    shouldShowSearch: state => state.currentAdditionalNav == 'search',
    subNavIsOpen: state => state.subNavIsOpen,
    topics: state => state.topics,
    getNoticeMessageByContext: state => context => state.noticeMessagesByContext[context],
  },
}

// Helper functions
function trackEvents(newAdditionalNav, currentAdditionalNav) {
  if (currentAdditionalNav === '') {
    if (newAdditionalNav === 'mini-cart') On.Analytics.trackMiniCart.open()
    if (newAdditionalNav === 'search') On.Analytics.trackSiteSearch.open()
  } else {
    setTimeout(() => {
      // Has to be timeouted for the case where the mouse is over the additional nav icon and flows into the mini cart.
      // There currentAdditionalNav gets reset to '' and set to 'mini-cart' right after again.
      // With the timeout we check if the overlay really was closed or not.
      if (!On.Store.state.nav.overlayIsOpen) {
        if (currentAdditionalNav === 'mini-cart') On.Analytics.trackMiniCart.close()
        if (currentAdditionalNav === 'search') On.Analytics.trackSiteSearch.close()
      }
    }, 100)
  }
}
